import React from 'react';
import { Link } from 'react-router-dom';
import { UserConsumer } from '../../../contexts/UserContext';
import RemoveOrgUser from '../../RemoveOrgUser';
import styles from '../../../containers/Lookup/DisplayOrganization.module.css';
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from '@mui/material';

export default class UserOrgsTable extends React.Component {
  state = {
    modalOpen: false,
    modalLoading: false,
    modalErrors: {
      server_message: null,
    },
  };

  render() {
    return (
      <UserConsumer>
        {(user) => {
          const hasRemovePermission =
            user.roleNames.includes('admin') ||
            user.roleNames.includes('insights_user_manager');
          let userOrgs = this.props.userOrganizations;
          return (
            <React.Fragment>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Account ID</TableCell>
                    <TableCell>Organization ID</TableCell>
                    <TableCell>Organization Name</TableCell>
                    <TableCell>Access Level</TableCell>
                    {hasRemovePermission && (
                      <TableCell>Remove from Organization</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userOrgs.map((uo) => {
                    return (
                      <TableRow key={uo.organization.id}>
                        <TableCell>
                          <Link
                            to={`/lookup/account_id/${uo.organization.account_id}`}
                          >
                            <span data-hj-suppress>
                              {uo.organization.account_id}
                            </span>
                          </Link>
                        </TableCell>
                        <TableCell>
                          <Link
                            to={`/lookup/organization_id/${uo.organization.id}`}
                          >
                            <span data-hj-suppress>{uo.organization.id}</span>
                          </Link>
                        </TableCell>
                        <TableCell>
                          <span data-hj-suppress>{uo.organization.name}</span>
                        </TableCell>
                        <TableCell>{uo.access}</TableCell>
                        {hasRemovePermission && (
                          <TableCell className={styles.removeButtonCell}>
                            <RemoveOrgUser
                              user={uo.user}
                              organization={uo.organization}
                              onSuccess={this.props.onSuccess}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </React.Fragment>
          );
        }}
      </UserConsumer>
    );
  }
}
